import { render, staticRenderFns } from "./dylbanner.vue?vue&type=template&id=28007b87&scoped=true"
import script from "./dylbanner.vue?vue&type=script&lang=js"
export * from "./dylbanner.vue?vue&type=script&lang=js"
import style0 from "./dylbanner.vue?vue&type=style&index=0&id=28007b87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28007b87",
  null
  
)

export default component.exports